import React, { useState } from 'react';
import MetricsOverview from '../components/dashboard/MetricsOverview';
import RevenueChart from '../components/charts/RevenueChart';
import CustomerGrowthChart from '../components/charts/CustomerGrowthChart';
import SubscriptionPlans from '../components/dashboard/SubscriptionPlans';
import CohortAnalysis from '../components/dashboard/CohortAnalysis';
import { CalendarIcon, FilterIcon } from 'lucide-react';
const Dashboard = () => {
  const [dateRange, setDateRange] = useState('last30Days');
  return <div className="space-y-6">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <h1 className="text-2xl font-bold text-gray-800">Dashboard</h1>
        <div className="flex flex-wrap gap-2">
          <div className="relative">
            <select value={dateRange} onChange={e => setDateRange(e.target.value)} className="appearance-none pl-10 pr-10 py-2 border border-gray-300 bg-white rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm">
              <option value="last7Days">Last 7 days</option>
              <option value="last30Days">Last 30 days</option>
              <option value="last90Days">Last 90 days</option>
              <option value="lastYear">Last year</option>
              <option value="custom">Custom range</option>
            </select>
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <CalendarIcon size={16} className="text-gray-500" />
            </div>
          </div>
          <button className="flex items-center px-4 py-2 border border-gray-300 bg-white rounded-md hover:bg-gray-50 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm">
            <FilterIcon size={16} className="mr-2 text-gray-500" />
            Filters
          </button>
        </div>
      </div>
      <MetricsOverview />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <RevenueChart />
        <CustomerGrowthChart />
      </div>
      <SubscriptionPlans />
      <CohortAnalysis />
    </div>;
};
export default Dashboard;